import { RootState } from '../core'

export const selectConversations = (state: RootState) => state.conversations.items

export const selectActiveConversationId = (state: RootState) => state.conversations.activeId
